export default __webpack_public_path__ + "static/media/time.151a4496.svg";